module.exports = __webpack_public_path__ + "img/53.9b396a8d.jpg";